import { Head } from "@inertiajs/react"
import AdminLayout from "../../../layouts/AdminLayout"
import TopicForm from "./Form"

type Props = {
  topic: {
    id: number | null
    name: string
    summary: string | null
    jp: string | null
    slug: string | null
    banner_url: string | null
  }
  errors?: Record<string, string[]>
}

export default function NewTopic({ topic, errors }: Props) {
  return (
    <AdminLayout title="New topic">
      <Head title="New topic" />
      <TopicForm topic={topic} errors={errors} />
    </AdminLayout>
  )
}
